import ReactToPrint from 'react-to-print';
import InvoiceNewPage from './invoiceNewPage';
import { useRef } from 'react';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import { setToolbarButtons } from '../../redux/features/toolbarSlice';
import { toolbarConstants } from '../../constants/toolbar/toolbarConstants';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ACTION_MAIN_BOTTOM_BAR_JSX,
  ACTION_OPEN_TOOLBAR,
  ACTION_RESET,
  ACTION_SET_APPBAR_JSX,
  ACTION_SET_TOOLBAR_JSX,
} from '../../component/MainUIFrame/constants';
import EHRToolbar from '../../component/Toolbar/toolbarContent';
import { clearChargeItem } from '../../redux/features/invoiceSlice';
import EHRBottomBar from '../Practitioner/contents/bottomBarContent';
import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../component/MainUIFrame/MainFrame';
import { ArrowBack } from '@mui/icons-material';

const PrintInvoice = props => {
  let componentRef = useRef();
  const location = useLocation();
  const printButtonRef = useRef();
  const reduxDispatch = useDispatch();
  const dispatch = useMainFrameDispatch();
  const [isPrint, setPrint] = useState(false);
  const state = location.state || {};
  const [invoiceObject, setInvoiceObject] = useState(state.invoiceObject || {});
  const navigate = useNavigate();
  const { isDark } = useMainFrameState();
  useEffect(() => {
    console.log('state of dark mode ', isDark);
  }, []);

  const AppBarJsx = props => {
    return (
      <Grid container>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {!state.listView && (
            <IconButton>
              <ArrowBack
                onClick={() => handleOnClose()}
                sx={{
                  color: 'appBarIcon',
                }}
              />
            </IconButton>
          )}
          <Typography
            sx={{
              color: 'appBarIcon',
            }}
            variant="h5"
          >
            {'Invoice'}
          </Typography>
        </Box>
      </Grid>
    );
  };

  useEffect(() => {
    dispatch({
      type: ACTION_SET_APPBAR_JSX,
      payload: (
        <AppBarJsx handleOnClose={handleOnClose} listView={state.listView} />
      ),
    });
  }, [state.listView]);

  const handleOnClose = () => {
    navigate('/invoice');
  };

  useEffect(() => {
    if (isPrint === true) {
      printButtonRef.current.click();
      setPrint(false);
    }
  }, [isPrint]);

  useEffect(() => {
    dispatch({ type: ACTION_OPEN_TOOLBAR });
    dispatch({
      type: ACTION_SET_TOOLBAR_JSX,
      payload: <EHRToolbar />,
    });
    dispatch({ type: ACTION_SET_APPBAR_JSX, payload: <AppBarJsx /> });
    return () => {
      dispatch({
        type: ACTION_RESET,
      });
      reduxDispatch(clearChargeItem());
    };
  }, []);

  //cc//
  useEffect(() => {
    dispatch({
      type: ACTION_MAIN_BOTTOM_BAR_JSX,
      payload: <EHRBottomBar />,
    });

    return () => {
      dispatch({
        type: ACTION_RESET,
      });
    };
  }, []);

  return (
    <Grid item xs={12}>
      {/* button to trigger printing of target component */}
      {state?.isEdit && (
        <ReactToPrint
          trigger={() => (
            <Button
              style={{ margin: '10px', display: 'none' }}
              variant="contained"
              ref={printButtonRef}
            >
              Print Invoice
            </Button>
          )}
          /* trigger={() =>{
            <Button>Print Invoice</Button>
          }} */
          content={() => componentRef?.current}
          bodyClass={isDark ? 'dark-mode-invoice' : ''}
        />
      )}

      {/* component to be printed */}
      <InvoiceNewPage
        ref={componentRef}
        invoiceObject={invoiceObject}
        patientDetails={state.getPatinetDetails}
        isEdit={state.isEdit}
        listView={state.listView}
        // setListView={props.setListView}
        // setSelectionModel={props.setSelectionModel}
        // setDisabled={props.setDisabled}
        setPrint={setPrint}
        setInvoiceObject={setInvoiceObject}
      />
    </Grid>
  );
};

export default PrintInvoice;
